import MainLayout from "@/components/layout/MainLayout.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
    name: "classSessionDetail",

    components: {
        MainLayout
    },

    data() {
        return {
            session : {},
            classId : ''
        };
    },

    computed: {
        ...mapGetters(["userType"]),
    },

    methods: {
        getClassSessionDetail() {
          this.classId = this.$route.params.class_id;
          axios.get(`class/session/${this.$route.params.class_id}/info/${this.$route.params.id}`)
          .then((res) => {
            this.session = res.data;
          }).catch((error) => {
            if (error.response.status == 404) {
              this.$router.push({ name: 'notFound'
              });
            } else if(error.response.status == 403) {
              this.$router.push({ name: 'forbidden'
              });
            }
            console.log(error)
          })
        },
        customFormatter(time) {
          if (!time) return "";
          return moment(time, "HH:mm:ss").format('HH:mm');
        },
    },

    mounted() {
      this.getClassSessionDetail()
    }
};
